import React from 'react';

import { WorksheetPageIndex } from 'services/worksheet/types';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import Bold from 'components/Bold';
import FertilizerPrintWorksheetProductsTable from './components/FertilizerPrintWorksheetProductsTable';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetProducts(
    props: Props
): React.ReactElement {
    const { pageIndex } = props;

    return (
        <div className="print-worksheet-page-section">
            <Grid columns="1">
                <GridRow>
                    <GridColumn>
                        <Bold>Product details</Bold>
                    </GridColumn>
                </GridRow>
            </Grid>
            <FertilizerPrintWorksheetProductsTable pageIndex={pageIndex} />
        </div>
    );
}
